<template>
  <v-dialog v-model="showConfirmationDialog" width="700" persistent>
    <v-card>
      <v-container>
      <v-card-title style="font-size: 18px; font-weight: bold; display: flex; align-items: center; justify-content: space-between;">{{ $t('Внимание!') }}<v-icon icon="mdi-close" @click="confirmChoice(constants.NOLOAD)"/>
      </v-card-title>
      <v-card-subtitle style="font-size: 16px; font-weight: bold; opacity: 1;">{{ $t('Обнаружены существующие категории. Как обработать загружаемый файл?') }}</v-card-subtitle>

      <v-table density="compact">
        <tbody>
        <tr>
          <th>{{ $t('Перезаписать:') }}</th>
          <td>{{ $t('все текущие категории будут удалены, останутся только данные из файла.') }}</td>
        </tr>
        <tr>
          <th>{{ $t('Дозагрузить:') }}</th>
          <td>{{ $t('новые категории добавятся к уже имеющимся.') }}</td>
        </tr>
        </tbody>
      </v-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          variant="flat"
          width="160px"
          style="border-radius: 6px !important;"
          @click="confirmChoice(constants.RELOAD)">{{ $t('Перезаписать') }}</v-btn>
        <v-btn
          color="primary"
          variant="flat"
          width="160px"
          style="border-radius: 6px !important;"
          @click="confirmChoice(constants.UPLOAD)">{{ $t('Дозагрузить') }}</v-btn>
      </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { toast } from '@/lib/toast';

export default {
  data() {
    return {
      showConfirmationDialog: false,
      confirmationResult: null,
      constants: {
        NOLOAD: 0,
        RELOAD: 1,
        UPLOAD: 2
      },
      maxRowsCount: 100
    }
  },
  props: {
    categories: Object
  },
  methods: {
    async performCheck(categories) {
      if (this.categories.totalEntries > 0) {
        this.confirmationResult = null;
        this.showConfirmationDialog = true;

        while (this.confirmationResult == null) {
          await this.waitForConfirmation();

          switch (this.confirmationResult) {
            case this.constants.RELOAD:
              this.categories.items.splice(0, this.categories.totalEntries, ...categories);
              break;
            case this.constants.UPLOAD:
              if (this.categories.totalEntries + categories.length > this.maxRowsCount) {
                toast.error(
                  this.$t('Превышено максимально допустимое количество категорий:') + "\n" +
                  this.$t('В системе разрешено не более {_1} категорий поставщиков.', {'_1': this.maxRowsCount}) + "\n" +
                  this.$t('Сейчас на форме: {_1}, в файле: {_2}.', {'_1': this.categories.totalEntries, '_2': categories.length}) + "\n" +
                  this.$t('Дозагрузка невозможна.')
                );
                this.confirmationResult = null;
              } else {
                this.categories.items.splice(this.categories.totalEntries, 0, ...categories);
              }
              break;
          }
        }
      } else {
        this.categories.items.splice(0, 0, ...categories);
      }
      this.showConfirmationDialog = false;
    },

    waitForConfirmation() {
      return new Promise((resolve) => {
        const watcher = this.$watch(
          () => this.confirmationResult,
          (newValue) => {
            if (newValue !== null) {
              resolve(newValue);
              watcher();
            }
          }
        );
      });
    },

    confirmChoice(choice) {
      this.confirmationResult = choice;
    }
  },
};
</script>

<style scoped>
.v-table .v-table__wrapper > table > tbody > tr > th {
  padding-left: 35px !important;
  font-weight: bold !important;
}

.v-table .v-table__wrapper > table > tbody > tr > td,
.v-table .v-table__wrapper > table > tbody > tr > th {
  height: 20px;
  border: none !important;
  vertical-align: top !important;
}

.v-table {
  padding: 10px 0;
}
</style>